export const MAX_PRICE = 49999999;
//# sourceMappingURL=constants.js.map